'use client'

import React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { CommitmentTerm } from '../cells/types'

interface CommitmentDropdownProps {
  value: CommitmentTerm
  onValueChange: (value: CommitmentTerm) => void
  className?: string
}

/**
 * Dropdown for selecting commitment term length
 * Supports 6, 12, 24, and 36 month terms
 */
export const CommitmentDropdown: React.FC<CommitmentDropdownProps> = ({
  value,
  onValueChange,
  className,
}) => {
  return (
    <>
      <p id="commitment-instructions" className="sr-only">
        Select a commitment term to update prices in the table below
      </p>
      <Select value={value} onValueChange={(val: CommitmentTerm) => onValueChange(val)}>
        <SelectTrigger
          className={`w-[175px] h-auto gap-2.5 px-3 py-2 border-civo-cloud bg-white rounded-lg body-xsmall text-black/70 ${className || ''}`}
          aria-describedby="commitment-instructions"
        >
          <SelectValue>Commitment - {value} months</SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-white rounded-lg border-civo-cloud">
          <SelectItem
            value="6"
            className="body-xsmall text-black/70 focus:bg-black/[0.02] focus:text-black/70"
          >
            6 months
          </SelectItem>
          <SelectItem
            value="12"
            className="body-xsmall text-black/70 focus:bg-black/[0.02] focus:text-black/70"
          >
            12 months
          </SelectItem>
          <SelectItem
            value="24"
            className="body-xsmall text-black/70 focus:bg-black/[0.02] focus:text-black/70"
          >
            24 months
          </SelectItem>
          <SelectItem
            value="36"
            className="body-xsmall text-black/70 focus:bg-black/[0.02] focus:text-black/70"
          >
            36 months
          </SelectItem>
        </SelectContent>
      </Select>
    </>
  )
}
